import { Component, OnInit } from '@angular/core';
import { fromEvent, Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-offline-detector',
  templateUrl: './offline-detector.component.html',
  styleUrls: ['./offline-detector.component.css']
})
export class OfflineDetectorComponent implements OnInit {

  constructor() { }

  offlineEvent: Observable<Event>;
  onlineEvent: Observable<Event>;
  subscriptions: Subscription[] = [];
  isOffline: boolean;
  
  ngOnInit(): void {
    this.handleAppConnectivityChanges();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  handleAppConnectivityChanges(): void {
    this.offlineEvent = fromEvent(window, 'offline');
    this.onlineEvent = fromEvent(window, 'online');
    
    this.subscriptions.push(this.offlineEvent.subscribe(e => {
      // handle offline mode
      console.log('Offline event subscription function triggered');
      this.isOffline = true;
    }));

    
    this.subscriptions.push(this.onlineEvent.subscribe(e => {
      // handle online mode
      console.log('Online event subscription function triggered');
      this.isOffline = false;
    }));

  }




}
